import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import DropdownFormInput from '../../common/Forms/DropdownForm';
import { setOrgId } from '../../../redux/contact/referralSourcesForm/referralSourcesFormSlice';
import { postStopApi, setStopApi } from '../../../services/StopApi/StopApi';
import {
  CONTACT_FORM_UPDATE_URL,
  CONTACT_REFERRAL_SOURCES_UPDATE_URL,
  paperProps,
} from '../../../constants';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../../common/commonUtils/commonUtils';
import { getContactForm } from '../../../redux/contact/contactForm/contactFormSlice';
import { Form } from '../../ui/styled';

const ReferralSourcesDialog = (props) => {
  const { open, setOpen, openBackdrop, authToken } = props;

  const dispatch = useDispatch();
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewReferralSourceForm, setIsNewReferralSourceForm] = useState(false);

  const contactForm = useSelector((state) => state.contactForm);
  const { cntId } = contactForm;

  const referralSourceForm = useSelector((state) => state.referralSourceForm);
  const { newReferralSourceForm, orgContactId, orgId } = referralSourceForm;

  const contactReferenceData = useSelector(
    (state) => state.contactReferenceData
  );
  const { referralSourcesList } = contactReferenceData;

  const fetchData = async () => {
    const commonParams = `${CONTACT_FORM_UPDATE_URL}/${cntId}`;
    const authorization = authToken;
    dispatch(getContactForm({ commonParams, authorization }));
  };

  const defaultValue = {
    orgContactId: orgContactId,
    orgId: orgId ? orgId : '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });
  const { handleSubmit, reset, control, register } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.orgContactId, defaultValue.orgId]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${CONTACT_REFERRAL_SOURCES_UPDATE_URL}`;
    const authorization = authToken;
    const payload = {
      orgContactId: newReferralSourceForm ? 0 : orgContactId,
      orgCntContactId: cntId,
      orgId: orgId,
      orgCntPge3Yn: true,
    };
    if (newReferralSourceForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewReferralSourceForm(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewReferralSourceForm(false);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const getOrganizationContactForm = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DropdownFormInput
            name='orgId'
            control={control}
            options={referralSourcesList}
            defaultId={defaultValue?.orgId}
            label='Referral Sources'
            register={register('orgId', {
              onChange: (e) => dispatch(setOrgId(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={paperProps}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>
            {getDialogHeading(
              'Referral Sources ID',
              defaultValue?.orgContactId,
              handleClose
            )}
            <Form>
              {getOrganizationContactForm()}
              {getSaveCancel(handleClose, null, handleSubmit(onSubmit))}
            </Form>
          </>
        )}
      </Dialog>
      {getFormSuccess(formSuccess, setFormSuccess, isNewReferralSourceForm)}
    </>
  );
};

export default ReferralSourcesDialog;
